import { Range, RangeProps } from 'rc-slider'
import styled from 'styled-components'
import { FC } from 'react'

type RangeSliderProps = RangeProps & Rest

const RangeSliderRedesign: FC<RangeSliderProps> = ({ step = 1, ...rest }) => {
  return <StyledRange step={step} allowCross={false} {...rest} />
}

export default RangeSliderRedesign

const StyledRange = styled(Range)`
  .rc-slider-handle {
    margin-top: -6px;
    background-color: ${(props) => props.theme.colors.background};
    width: 18px;
    height: 18px;
    border: none !important;
    box-shadow: 
      0.25px -2px 20px 0px #0000000d inset,
      0.5px 0.5px 1px 0px #ffffff inset,
      0 2px 6px rgba(0,0,0,0.2);
}
  }
  .rc-slider-handle-dragging {
    box-shadow: 
      0.25px -2px 20px 0px #0000000d inset,
      0.5px 0.5px 1px 0px #ffffff inset,
      0 2px 6px rgba(0,0,0,0.2) !important;
  }
  .rc-slider-rail {
    height: 8px !important;
    background-color: ${(props) => props.theme.colors.navMenuGrey};
  }
  .rc-slider-track {
    height: 8px !important;
    background-color: ${(props) => props.theme.colors.onBackground} !important;
  }
`
